
import Pagination from 'react-bootstrap/Pagination';

const PaginationControl = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  return (
   

      <Pagination className="custom-pagination d-flex gap-2">

        {/* ◀ Prev button */}
        <button
          className="btn btn-outline-secondary pb-0 px-2"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          style={{
            border: currentPage === 1 ? 'none' : '1px solid #C4CDD5',
            color: currentPage === 1 ? '#C4CDD5' : '#000000',
          }}
        >
          <h6>
            <i className="bi bi-chevron-left" />
          </h6>
        </button>

        {/* Page 1 */}
        <Pagination.Item
          active={currentPage === 1}
          onClick={() => onPageChange(1)}
        >
          1
        </Pagination.Item>

        {/* Page 2 (for >4 pages) */}
        {totalPages > 4 && (
          <Pagination.Item
            active={currentPage === 2}
            onClick={() => onPageChange(2)}
          >
            2
          </Pagination.Item>
        )}

        {/* Ellipsis after page 2 */}
        {currentPage > 3 && totalPages > 4 && (
          <Pagination.Ellipsis disabled />
        )}

        {/* Middle current page */}
        {currentPage > 2 && currentPage < totalPages - 1 && (
          <Pagination.Item active>{currentPage}</Pagination.Item>
        )}

        {/* Ellipsis before last page */}
        {currentPage < totalPages - 2 && totalPages > 4 && (
          <Pagination.Ellipsis disabled />
        )}

        {/* Second-to-last page */}
        {totalPages > 4 && (
          <Pagination.Item
            active={currentPage === totalPages - 1}
            onClick={() => onPageChange(totalPages - 1)}
          >
            {totalPages - 1}
          </Pagination.Item>
        )}

        {/* Last page */}
        <Pagination.Item
          active={currentPage === totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>

        {/* ▶ Next button */}
        <button
          className="btn btn-outline-secondary pb-0 px-2"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          style={{
            border:
              currentPage === totalPages ? 'none' : '1px solid #C4CDD5',
            color: currentPage === totalPages ? '#C4CDD5' : '#000000',
          }}
        >
          <h6>
            <i className="bi bi-chevron-right" />
          </h6>
        </button>
      </Pagination>
  
  );
};

export default PaginationControl;
